import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "offset-md-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Current Smoking Status")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "form-group col-md-4 pe-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "smoking-status" }, " Smoking Status ", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Smoking Status", -1 /* HOISTED */)
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "form-group col-md-4 px-1"
}
const _hoisted_9 = { for: "smokingStartDate" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Start Date ")
const _hoisted_11 = {
  key: 0,
  class: "text-danger ms-1"
}
const _hoisted_12 = { class: "input-group date datepickerInput" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_15 = {
  key: 1,
  class: "form-group col-md-4 px-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "smokingEndDate" }, " Stop Date ", -1 /* HOISTED */)
const _hoisted_17 = { class: "input-group date datepickerInput" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_20 = { class: "offset-md-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Historical Smoking Status")
], -1 /* HOISTED */)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "form-group col-md-4 pe-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "historical-smoking-status" }, " Smoking Status ", -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Smoking Status", -1 /* HOISTED */)
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "form-group col-md-4 px-1"
}
const _hoisted_28 = { for: "historicalSmokingStartDate" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Start Date ")
const _hoisted_30 = {
  key: 0,
  class: "text-danger ms-1"
}
const _hoisted_31 = { class: "input-group date datepickerInput" }
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_34 = {
  key: 1,
  class: "form-group col-md-4 px-1"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "historicalSmokingEndDate" }, [
  /*#__PURE__*/_createTextVNode(" Stop Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_36 = { class: "input-group date datepickerInput" }
const _hoisted_37 = ["value"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patientHealthHistory.smokingStatus) = $event)),
            id: "smoking-status"
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.smokingStatusEnum), ([key, value]) => {
              return (_openBlock(), _createElementBlock("option", {
                value: value.value
              }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_7))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vModelSelect, _ctx.patientHealthHistory.smokingStatus]
          ])
        ]),
        (!_ctx.canHideSmokingDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, [
                _hoisted_10,
                (_ctx.patientHealthHistory.smokingStatus)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
                  : _createCommentVNode("v-if", true)
              ]),
              _createVNode(_component_DatePicker, {
                options: _ctx.startDatePickerOptions,
                getDate: _ctx.handleDateChange
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "smokingStartDate",
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.patientHealthHistory.smokingStartDate),
                      autocomplete: "off",
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_13),
                    _hoisted_14
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["options", "getDate"])
            ]))
          : _createCommentVNode("v-if", true),
        (!_ctx.canHideSmokingDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_DatePicker, {
                options: _ctx.endDatePickerOptions,
                getDate: _ctx.handleDateChange
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "smokingEndDate",
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.patientHealthHistory.smokingEndDate),
                      autocomplete: "off",
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_18),
                    _hoisted_19
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["options", "getDate"])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            id: "historical-smoking-status",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.patientHealthHistory.historicalSmokingStatus) = $event))
          }, [
            _hoisted_25,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.smokingStatusEnum), ([key, value]) => {
              return (_openBlock(), _createElementBlock("option", {
                value: value.value
              }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_26))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vModelSelect, _ctx.patientHealthHistory.historicalSmokingStatus]
          ])
        ]),
        (!_ctx.canHideHistoricalSmokingDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, [
                _hoisted_29,
                (_ctx.patientHealthHistory.historicalSmokingStatus)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, "*"))
                  : _createCommentVNode("v-if", true)
              ]),
              _createVNode(_component_DatePicker, {
                options: _ctx.historicalStartDatePickerOptions,
                getDate: _ctx.handleDateChange
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "historicalSmokingStartDate",
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.patientHealthHistory.historicalSmokingStartDate),
                      autocomplete: "off",
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_32),
                    _hoisted_33
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["options", "getDate"])
            ]))
          : _createCommentVNode("v-if", true),
        (!_ctx.canHideHistoricalSmokingDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_DatePicker, {
                options: _ctx.historicalEndDatePickerOptions,
                getDate: _ctx.handleDateChange
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "historicalSmokingEndDate",
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.patientHealthHistory.historicalSmokingEndDate),
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_37),
                    _hoisted_38
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["options", "getDate"])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}